import moment from "moment";
import "moment/locale/es";
import {cuentaMask, dineroDisabledMask} from '../Components/Items'
import { HeaderEmpresaCard } from "../Components/PdfComponents/HeaderEmpresaCard";

moment.locale("es");

const reportesDePedidosPdf = (values) => {
    const empresa = values.empresa
    const logoBiwo = values.logoBiwo;
    let filtrados = []
    if(values.clientes !== 0 && values.clientes && values.clientes.length > 0){
        let textoFiltrado = ''
        values.clientes.map((valueCliente) => {
            textoFiltrado += `${(valueCliente.persona ? valueCliente.nombre : (valueCliente.nombre+' '+valueCliente.apellidoPaterno+' '+valueCliente.apellidoMaterno)) + valueCliente.razonSocial + " - " + valueCliente.rfc}\n`
            return null
        })
        filtrados.push([
            {text: 'Clientes:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.vendedores !== 0 && values.vendedores && values.vendedores.length > 0){
        let textoFiltrado = ''
        values.vendedores.map((valueVendedores) => {
            textoFiltrado += `${valueVendedores.nombre +
                " " +
                valueVendedores.apellidoPaterno +
                " " +
                valueVendedores.apellidoMaterno}\n`
            return null
        })
        filtrados.push([
            {text: 'Vendedores:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 1){
        let textoFiltrado = ''
        values.proyectos.map((valueProyectos) => {
            textoFiltrado += `${valueProyectos.nombre}\n`
            return null
        })
        filtrados.push([
            {text: 'Proyectos:', style: 'subheader'},
            
            {text: textoFiltrado, style: 'textoChico'}
          ])
    }

    if(values.filtrarProyecto === 2){
        filtrados.push([
            {text: 'Unidad de Negocio:', style: 'subheader'},
            
            {text: `${cuentaMask(
                values.unidadDeNegocio.nivel1 + values.unidadDeNegocio.nivel2 + values.unidadDeNegocio.nivel3 + values.unidadDeNegocio.nivel4 +values.unidadDeNegocio.nivel5
              ) +
                " - " +
                values.unidadDeNegocio.nombre}`, style: 'textoChico'}
          ])
    }

    let pedidos = []

    for(const valuePedido of values.pedidos){
        const properties = valuePedido.colorStyle ? {background: valuePedido.colorStyle} : {}
        pedidos.push([
            {text: valuePedido.folio, style: 'textoTabla', alignment: 'left'}, 
            {text: isNaN(valuePedido.fechaFactura) ? moment(valuePedido.fechaFactura, "DD/MM/YYYY").locale('es').format('L') : valuePedido.fechaFactura, style: 'textoTabla', alignment: 'center'}, 
            {text: valuePedido.cliente, style: 'textoTabla', alignment: 'left'},
            {text: (typeof valuePedido.fechaVencimiento === 'string' && moment(valuePedido.fechaVencimiento, "DD/MM/YYYY", true).isValid()) ? moment(valuePedido.fechaVencimiento, "DD/MM/YYYY").locale('es').format('L') : 'No tiene', style: 'textoTabla', alignment: 'center'},
            {text: dineroDisabledMask(valuePedido.totalPagar), style: 'textoTabla', alignment: 'right'},
            {text: valuePedido.estado, ...properties, style: 'textoTabla', alignment: 'left'},
            {text: valuePedido.vendedor, style: 'textoTabla', alignment: 'left'},
        ])
    }

    let totalPedidos = values.pedidos.reduce((acc, val) => acc + parseFloat(val.total || 0), 0);

    pedidos.push([
        { text: 'TOTAL:', style: 'totalChico', alignment: 'left', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: dineroDisabledMask(totalPedidos), style: 'totalChico', alignment: 'right', border: [true, true, true, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, false, true], fillColor: '#cccccc' },
        { text: '', style: 'totalChico', border: [false, true, true, true], fillColor: '#cccccc' },
    ]);
    



    if(filtrados.length === 0){
        filtrados.push([
            {text: 'No tiene filtrados adicionales', style: 'subheader'},

            {text: '', style: 'textoChico'}
      ] )
    }

    var dd = {
        footer: {
            image: 'logoBiwo', alignment: 'center', width: 80
        },
          content: [
              {
                  style: 'tableExample',
                  table: {
                      widths: [ '18%', '52%', '30%'],
                      layout: {
                          defaultBorder: false,
                      },
                      body: [
                          [
                              ...HeaderEmpresaCard(empresa, false,false,
                              {
                                  border: [false, false, false, false],
                                      table: {
                                      headerRows: 1,
                                      widths: ['100%'],
                                  
                                      body: [
                                          [{text: 'Fecha Inicial:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaInicial).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha Final:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment(values.fechaFinal).locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                          [{text: 'Fecha de Impresión:', style: 'subheader', alignment: 'center'}],
                                          [{text: moment().locale('es').format('LL'), style: 'textoChico', alignment: 'center'}],
                                      ]
                                  },
                                  layout: 'noBorders'
                              }),
                          ]
      
                      ]
                  },
              },
              {
                text:
                "Reporte de Pedidos",
                style: "tableHeaderIzquierda",
              },
              {text: 'Datos de filtrado:'},
              {
                  style: 'tableExample',
                  table: {
                      widths: ['20%', '80%'],
                      layout: {
                                          defaultBorder: false,
                                      },
                      
                      body: filtrados,
                  },
                              layout: {
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
                  
              },
              
              {
                  style: 'tableExample',
                  table: {
                      widths: ["10%", "10%", "20%", "10%", "20%", "10%", "20%"],
                      layout: {
                          defaultBorder: true,
                      },
                      body: [
                          [
                            {text: 'Folio', style: 'tituloTabla'},		              
                            {text: 'Fecha', style: 'tituloTabla'},
                            {text: 'Cliente', style: 'tituloTabla'},
                            {text: 'Vencimiento', style: 'tituloTabla'},
                            {text: 'Total', style: 'tituloTabla'},
                            {text: 'Estado', style: 'tituloTabla'},
                            {text: 'Vendedor', style: 'tituloTabla'},
                          ],
                          ...pedidos
                      ]
                  },
                  layout: {
                      fillColor: (rowIndex, node, columnIndex) => {
                          return rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff";
                      },
                      hLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.body.length) ? 1 : 1;
                      },
                      vLineWidth: function (i, node) {
                          return (i === 0 || i === node.table.widths.length) ? 1 : 1;
                      },
                      hLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      vLineColor: function (i, node) {
                          return '#adaaaa';
                      },
                      hLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.body.length) {
                              return null;
                          }
                          return {dash: {length: 2, space: 1}};
                      },
                      vLineStyle: function (i, node) {
                          if (i === 0 || i === node.table.widths.length) {
                              return null;
                          }
                          return {dash: {length: 2}};
                      },
                      // paddingLeft: function(i, node) { return 4; },
                      // paddingRight: function(i, node) { return 4; },
                      // paddingTop: function(i, node) { return 2; },
                      // paddingBottom: function(i, node) { return 2; },
                      // fillColor: function (i, node) { return null; }
                  }
              },
              
          ],
          images: {
            logo: empresa.logo.base64Completa,
            logoBiwo: logoBiwo.base64Completa,
          },
          styles: {
              tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
              header: {
                  fontSize: 9,
                  bold: true,
              },
              subheader: {
                  fontSize: 8,
                  bold: true,
              },
              tableExample: {
                  margin: [0, 5, 0, 5]
              },
              tablaSinMargen: {
                  margin: [0, 0, 0, 0]
              },
              tableHeader: {
                  bold: true,
                  fontSize: 12,
                  color: 'black',
                  alignment: 'center'
              },
              textoChico:{
                  fontSize: 8
              },
              tituloTabla:{
                  fontSize: 8,
                  bold: true, 
                  fillColor: '#cccccc', 
                  style: 'subheader', 
                  alignment: 'center',
                  border: true
              },
              textoTabla: {
                  fontSize: 8,
                  italics: false
              },
              totalChico: {
                fontSize: 6,
                bold: true,
                fillColor: '#cccccc',
                alignment: 'right',
                border: true
            }
            
          },
          pageSize: 'LETTER',
          pageMargins: [ 20, 20, 20, 60 ],
    }
  return dd;
};


export default reportesDePedidosPdf;
